const { getPWAConfig } = require("web-vault");
const env = window._siteProps_?.props?.build_env_var;
const countryFromDomain = window._siteProps_?.props?.countryFromDomain;
const envConfig = getPWAConfig(countryFromDomain)[env];

const isDesktop = (window._siteProps_?.platform).toLowerCase() === "desktop";
let isCorporateSite = window.location.origin.includes("corporate.dominos");
let isFeedbackSite = window.location.origin.includes("feedback.dominos");

// isCorporateSite = true;
// isFeedbackSite = true;

const IS_INDIA = countryFromDomain === 'INDIA';
const IS_SL = countryFromDomain === 'SRILANKA';
const IS_BG = countryFromDomain === "BANGLADESH";

let apiBaseUrl = window._siteProps_?.props?.apibaseurl;
let apiBaseUrl2 = window._siteProps_?.props?.apibaseurl2;
let apiBaseUrl3 = window._siteProps_?.props?.apibaseurl3;
let apiBaseUrlInternal = window._siteProps_?.props?.apiBaseUrlInternal
  ? window._siteProps_?.props?.apiBaseUrlInternal
  : "internal-s3-int-alb-51824138.ap-south-1.elb.amazonaws.com";
let imgBaseUrl = window._siteProps_?.props?.imgbaseurl;
let staticImgBaseUrl =
  window.location.origin + window._siteProps_?.props?.staticimgbaseurl;
let projectBasePathWithFolder =
  window.location.origin + window._siteProps_?.props?.projectbasepathwithfolder;
let paymentsProjectBasePathWithFolder =
  window.location.origin +
  window._siteProps_?.props?.paymentsprojectbasepathwithfolder;
let v2PwaBasePath = window.location.origin;
let postOrderUIBasePath = window?._siteProps_?.props?.postorderUIBasepath;
const defaultNextgenPathname = projectBasePathWithFolder + '/home';
let redirectToMapScreenAfterSeconds =
  +window._siteProps_?.props?.redirectToMapScreenAfterSeconds || 0;
let PROXY_PATH = "";
const shouldHideCompleteLoginFlow =
  window?._siteProps_?.props?.shouldHideCompleteLoginFlow === "true";
const shouldHideCompleteLocationFlow =
  window?._siteProps_?.props?.shouldHideCompleteLocationFlow === "true";
const shouldFetchLocationFromIp =
  window?._siteProps_?.props?.shouldFetchLocationFromIp === "true";
const oloApiEnvPath = window._siteProps_?.props?.oloApiEnvPath;
const shouldLoginFlowSkip =
  window?._siteProps_?.props?.shouldLoginFlowSkip === "true";
const homeMenuCategory =
  window?._siteProps_?.props?.homeMenuCategory || "menuV1";
const homeGuestMenuCategory =
  window?._siteProps_?.props?.homeGuestMenuCategory || "menuV1";
const themificationEnabled =
  window?._siteProps_?.props?.themificationEnabled === "true";
const categoriesForStrikePrice =
  window?._siteProps_?.props?.categoriesForStrikePrice || "";
const videoSwitch = window?._siteProps_?.props?.videoSwitch === "true";
const showIplNudgeModal =
  window?._siteProps_?.props?.showIplNudgeModal === "true";
const keyForEncryDecry = window?._siteProps_?.props.abstractKey;
const corporateOrderQtyLimit = JSON.parse(
  window?._siteProps_?.props?.corporateOrderQtyLimit || "200",
);
const showEdvForCorporate =
  window?._siteProps_?.props?.showEdvForCorporate === "true";
const keyForStoreStressRegister =
  window?._siteProps_?.props.pgVisitUrl || false;
const allowedPageForStoreStress =
  window?._siteProps_?.props.storeStressPageList || "";
const loyaltyProgramCode = window?._siteProps_?.props?.loyaltyProgramCode || "";
const timeoutPerformanceForStoreSressApi =
  window?._siteProps_?.props.timeoutPerformanceForStoreSressApi || 0;
const countryCodeFromDomain = window._siteProps_?.props?.countryCodeFromDomain;

//use on local if needed
// apiBaseUrl = "https://uat.dominos.co.in";
// apiBaseUrl2 = "https://s0.dominosindia.in";
// apiBaseUrl3 = "https://s3.dominosindia.in";
// staticImgBaseUrl = location.origin + "/discovery-ui-web/public/dist/default";
// projectBasePathWithFolder = location.origin + "/discovery-ui-web/en/pwa";
// paymentsProjectBasePathWithFolder =
//   location.origin + "/discovery-payment/en/pwa";
// projectBasePathWithFolder = location.origin + "/discovery-ui-web/en/dt";
// paymentsProjectBasePathWithFolder =
//   location.origin + "/discovery-payment/en/dt";
// v2PwaBasePath = "https://m.÷dominos.co.in";
// PROXY_PATH = "http://localhost:3002/";

const urls = {
  DOMINO_API_BASE_URL: PROXY_PATH + apiBaseUrl,
  DOMINO_API_BASE_URL2: PROXY_PATH + apiBaseUrl2,
  DOMINO_API_BASE_URL3: PROXY_PATH + apiBaseUrl3,
  DOMINO_INTERNAL_API_BASE_PATH: PROXY_PATH + apiBaseUrlInternal,
  GOOGLE_API_BASE_URL:
    PROXY_PATH + window._siteProps_?.props?.google_api_base_url,
};

const apiEndpoints = {
  REFRESH_TOKEN: urls.DOMINO_API_BASE_URL + "/loginhandler/refreshtoken",
  REFRESH_TOKEN_ANONYMOUS:
    urls.DOMINO_API_BASE_URL + "/loginhandler/refreshtokenanonymous",
  GEOCODE: urls.DOMINO_API_BASE_URL + "/locator-service/ve2/geocode",
  GOOGLE_GEO_LOCATION: urls.GOOGLE_API_BASE_URL + "/geolocation/v1/geolocate",
  LOCATOR_STORES: urls.DOMINO_API_BASE_URL + "/locator-service/ve2/stores",
  NEAREST_STORE:
    urls.DOMINO_API_BASE_URL3 + "/locator-service/ve3/nearest-store",
  LOCATOR_STORES_TAKEAWAY:
    urls.DOMINO_API_BASE_URL + "/locator-service/ve3/stores",
  STORE_OFFERS:
    urls.DOMINO_API_BASE_URL + "/nxg-middleware/ext/cart/v1/aggregateOffers",
  LEFT_MENU: urls.DOMINO_API_BASE_URL + "/catalog-service/ve1/stores",
  OFFER_TNC: urls.DOMINO_API_BASE_URL,
  APPLY_WELCOME_OFFER: urls.DOMINO_API_BASE_URL + "/agg/cart-service/ve1/cart",
  TRACK_ORDERS: urls.DOMINO_API_BASE_URL + "/tracker-service/ve2/orders",
  USER_LOYALTY: urls.DOMINO_API_BASE_URL + "/customer-service/ve1/loyalty/user",
  REGISTER_LOYALTY:
    urls.DOMINO_API_BASE_URL + "/customer-service/ve1/loyalty/register",
  STATIC_WIDGET_API:
    urls.DOMINO_API_BASE_URL +
    "/jfl-discovery-service/ve1/api/public/sites/v1/getWidgetStaticData",
  PERSONALIZATION_ITEMS:
    urls.DOMINO_API_BASE_URL2 +
    "/jfl-discovery-service/ve1/api/public/sites/v1/upsell-data",
  MENU_SEQUENCING:
    urls.DOMINO_API_BASE_URL2 +
    "/jfl-personalization/ve1/api/public/sites/v2/menu-data-sequence",
  WALLET_BALANCE:
    urls.DOMINO_API_BASE_URL + "/wallet-service/ve3/wallet/balance",
  ANONYMOUS_USER: urls.DOMINO_API_BASE_URL + "/loginhandler/anonymoususer",
  PIZZA_TOPPING: urls.DOMINO_API_BASE_URL + oloApiEnvPath,
  OLD_PREVIOUS_ORDER: urls.DOMINO_API_BASE_URL + "/order-service/ve1",
  PREVIOUS_ORDER:
    urls.DOMINO_API_BASE_URL +
    "/jfl-discovery-service/ue/api/public/sites/v1/store/",
  ESTIMENT_ORDER_TIME:
    urls.DOMINO_API_BASE_URL + "/order-service/ve1/orders/tracker/trackOnMap",
  SEND_TRACKER_STATUS:
    urls.DOMINO_API_BASE_URL + "/tracker-service/ve2/sendtrackerstatus",
  PAYMENT_OFFER_TNC:
    urls.DOMINO_API_BASE_URL3 +
    "/jfl-discovery-service/ve1/api/public/sites/v1/tnc",
  USER_ACTIVITY_TRACKING:
    urls.DOMINO_INTERNAL_API_BASE_PATH +
    "/user-activity-tracking/ve/v1/savePageViewData",
  PWA_CONFIG_API: urls.DOMINO_API_BASE_URL + "/api/ve1/pwa-config",
  APP_CONFIG_API: urls.DOMINO_API_BASE_URL + "/api/ve1/app-config",
  LOGIN_MINIAPP: urls.DOMINO_API_BASE_URL + "/auth-service/micro-app/ve1",
  SAVED_ADDRESS: urls.DOMINO_API_BASE_URL + "/customer-service/ve2/user",
  NPS_CSAT_HOME_WIDGET:
    urls.DOMINO_API_BASE_URL + "/feedback-service/ve1/feedback/widget",
  NPS_CSAT_DISMISS_HOME_WIDGET:
    urls.DOMINO_API_BASE_URL + "/feedback-service/ve1/feedback/widget/",
  DELETE_USER_ACCOUNT:
    urls.DOMINO_API_BASE_URL + "/customer-service/ve2/user/delete/generate/otp",
  CONFIRM_ACCOUNT_DELETE:
    urls.DOMINO_API_BASE_URL + "/customer-service/ve2/user/delete/confirm",
  SERVICE_GUARANTEE_BREAKDOWN:
    urls.DOMINO_API_BASE_URL +
    "/locator-service/ve2/service-guarantee/breakdown",
  SPLASH_SCREEN_API:
    urls.DOMINO_API_BASE_URL +
    "/jfl-discovery-service/ve1/api/public/sites/v1/splash",
  BEST_PRICE_GUARANTEE_API:
    urls.DOMINO_API_BASE_URL +
    "/jfl-discovery-service/ve1/api/public/sites/v1/getBpgData",
  ORDER_TRACKER_SUMMARY:
    urls.DOMINO_API_BASE_URL + "/post-order-service/ve1/tracker",
  GET_ORDERS_V3: urls.DOMINO_API_BASE_URL + "/order-service/ve3/orders",
  SG_ONECLICK_API: urls.DOMINO_API_BASE_URL,
  SG_CREATE:
    urls.DOMINO_API_BASE_URL + "/order-service/ve1/sg/one-click/create",
  SG_ONECLICK_STATUS: urls.DOMINO_API_BASE_URL + "/order-service/ve1/sg/status",
  TRANSACTION:
    urls.DOMINO_API_BASE_URL + "/order-service/ve3/orders/transaction",
  STORE_STRESS_RESIGTER: urls.DOMINO_API_BASE_URL + keyForStoreStressRegister,
  DITA_PICK_USER_ACTION:
    urls.DOMINO_API_BASE_URL + "/post-order-service/ve1/user/action",
};

export {
  envConfig,
  apiEndpoints,
  imgBaseUrl,
  isDesktop,
  isCorporateSite,
  isFeedbackSite,
  staticImgBaseUrl,
  projectBasePathWithFolder,
  paymentsProjectBasePathWithFolder,
  postOrderUIBasePath,
  v2PwaBasePath,
  defaultNextgenPathname,
  countryCodeFromDomain,
  countryFromDomain,
  redirectToMapScreenAfterSeconds,
  shouldHideCompleteLoginFlow,
  shouldHideCompleteLocationFlow,
  shouldFetchLocationFromIp,
  shouldLoginFlowSkip,
  homeMenuCategory,
  homeGuestMenuCategory,
  themificationEnabled,
  videoSwitch,
  showIplNudgeModal,
  loyaltyProgramCode,
  keyForEncryDecry,
  corporateOrderQtyLimit,
  showEdvForCorporate,
  getPWAConfig,
  keyForStoreStressRegister,
  allowedPageForStoreStress,
  timeoutPerformanceForStoreSressApi,
  IS_INDIA,
  IS_SL,
  IS_BG
};
